.registerWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: var(--ib-blush);
  padding: 2.5rem 1.5rem 4rem;
  min-height: 72vh;
}

.register {
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  background-color: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 10px 30px rgba(120, 30, 30, 0.08);
  padding: 2rem 2.25rem 2.5rem;
}

.header {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
}

.headerWrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}

.headerWrapper span {
  font-family: var(--font-serif);
  letter-spacing: -0.01em;
}

.registrationDetails {
  display: flex;
  flex-direction: column;
}

.accountTypesWrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.accountTypes {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.accountType {
  display: flex;
  flex-direction: column;
  margin-right: 0.5rem;
}

.accountTypeWrapper {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.attributesWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.5rem;
}

/* Consistent text inputs across the form (leaves radios/checkboxes/files alone) */
.register input:not([type='checkbox']):not([type='radio']):not([type='file']) {
  border: 1px solid var(--ib-line);
  border-radius: 8px;
  padding: 0.6rem 0.85rem;
  color: var(--ib-ink);
  font-variant-numeric: tabular-nums lining-nums;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.register input:not([type='checkbox']):not([type='radio']):not([type='file']):focus {
  outline: 0;
  border-color: var(--ib-red);
  box-shadow: 0 0 0 3px var(--ib-red-soft);
}

.detailsWrapper {
  margin-top: 2rem;
}

.uploadDetailsWrapper {
  margin-top: 1rem;
}

.divider {
  height: 1px;
  border-top: 1px solid var(--ib-line);
  margin-top: 3.5rem;
  margin-bottom: 1rem;
  margin-left: 15%;
  margin-right: 15%;
}

.halfdivider {
  composes: divider;
  margin-top: 2rem;
  margin-bottom: 0;
  margin-left: 40%;
  margin-right: 40%;
}

.tAndC {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
}

.register .submitBtn {
  margin-top: 2rem;
  align-self: flex-start;
  min-width: 200px;
  border-radius: 8px;
  padding: 0.7rem 1.6rem;
  font-weight: 600;
}

.errorMessage {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.errorMessageText {
  padding: 0 0.3rem;
}

.specialText {
  color: var(--green-secondary-color);
}

@media (max-width: 767.98px) {
  .register {
    padding: 1.5rem;
  }

  .submitBtn {
    width: 100%;
  }
}
